import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

let stagesCache = null;
export const invalidatePipeline = () => { stagesCache = null; };

export const usePipeline = () => {
  const [stages, setStages] = useState([]);
  const reload = useCallback(() => {
    stagesCache = stagesCache || api.get("/sales/pipeline").then((r) => r.data).catch(() => { stagesCache = null; return []; });
    return stagesCache.then(setStages);
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return { stages, reload: () => { invalidatePipeline(); return reload(); } };
};

export const QUOTE_STATUS = {
  bozza: { label: "Bozza", tone: "neutral" }, inviata: { label: "Inviata", tone: "blue" }, accettata: { label: "Accettata", tone: "green" },
  rifiutata: { label: "Rifiutata", tone: "red" }, scaduta: { label: "Scaduta", tone: "amber" }, annullata: { label: "Annullata", tone: "neutral" },
  revisionata: { label: "Sostituita da revisione", tone: "neutral" },
};
export const QUOTE_ACTIONS = { inviata: "Segna come inviata", accettata: "Accettata dal cliente", rifiutata: "Rifiutata dal cliente", scaduta: "Segna come scaduta", annullata: "Annulla offerta" };

export const ACTION_TYPES = [
  { key: "follow_up", label: "Follow-up" }, { key: "chiamata", label: "Chiamata" }, { key: "email", label: "Email" },
  { key: "appuntamento", label: "Appuntamento" }, { key: "offerta", label: "Offerta" }, { key: "attivita", label: "Attività" },
];
export const VISIBILITY = [
  { key: "public", label: "Standard (secondo i ruoli)" }, { key: "team", label: "Team" }, { key: "private", label: "Privata (solo responsabile)" },
  { key: "restricted", label: "Riservata (direzione)", confidential: true },
];
export const OPP_STATUS = { open: { label: "Aperta", tone: "blue" }, won: { label: "Vinta", tone: "green" }, lost: { label: "Persa", tone: "red" } };
export const UNITS = ["pz", "h", "gg", "mese", "anno", "forfait", "m", "kg", "licenza"].map((k) => ({ key: k, label: k }));
export const RECURRENCES = [{ key: "una_tantum", label: "Una tantum" }, { key: "mensile", label: "Canone mensile" }, { key: "trimestrale", label: "Canone trimestrale" },
  { key: "semestrale", label: "Canone semestrale" }, { key: "annuale", label: "Canone annuale" }];
export const recurrenceLabel = (k) => (k && k !== "una_tantum" ? RECURRENCES.find((r) => r.key === k)?.label : null);
export const VAT_RATES = [22, 10, 5, 4, 0].map((v) => ({ key: String(v), label: `${v}%` }));

const eur2 = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 2 });
export const fmtEur2 = (v) => eur2.format(v || 0);
const monthFmt = new Intl.DateTimeFormat("it-IT", { month: "long", year: "numeric" });
export const fmtMonth = (key) => (!key || key === "none" ? "Senza data" : monthFmt.format(new Date(`${key}-01T12:00:00`)));
export const todayIso = () => new Date().toISOString().slice(0, 10);
